module.exports = __webpack_public_path__ + "img/heilongjiang.ae57c2cc.png";